import './CarouselNavButton.css';

const CarouselNavButton = ({onClick, active}) => {
	let classList = "";
	if (active === true) {
		classList = "active";
	}

	return (
		<button className="carouselNavButton" onClick={onClick}>
			<div className={classList}></div>
		</button>
	);
}

export default CarouselNavButton;